import React from 'react'
import classNames from 'classnames'
import { UserTagType } from '../../UserTag'
import './SpeakingDistributionIcon.scss'

export interface SpeakingDistributionIconProps {
  percentage: number
  userType: UserTagType
}

export const SpeakingDistributionIcon: React.FC<SpeakingDistributionIconProps> = ({ percentage, userType }) => {
  const isAnonymous = userType === 'anonymous'
  return (
    <div
      className={classNames('d-flex zocks-py-0.125 zocks-px-0.25 align-items-center justify-content-center gap-2 speaking-distribution-icon-container', {
        'anonymous-border': isAnonymous,
        'non-anonymous-border': !isAnonymous,
      })}
    >
      <i className='bi bi-soundwave ' />
      <div className='paragraph-small'>{percentage}%</div>
    </div>
  )
}
